import { useState } from 'react'
import { isDemoMode, resetDemoData } from '../lib/api'

/**
 * Puts the demo story back to the start.
 *
 * Demo mode is stateful: answers, assignments, approvals and checklists all
 * stick, and they survive a refresh. That is the point, and it is also why this
 * exists. Between one walkthrough and the next, one tap rebuilds the seed with
 * every date recomputed from today's clock.
 *
 * Renders nothing at all once a real backend is configured.
 */
export function DemoResetButton({
  label = 'Reset demo data',
  className = 'btn btn--ghost btn--sm',
}: {
  label?: string
  className?: string
}) {
  const [busy, setBusy] = useState(false)

  if (!isDemoMode) return null

  async function reset() {
    if (busy) return
    const ok = window.confirm(
      'Start the demo again from the beginning? Everything tapped so far is undone.',
    )
    if (!ok) return
    setBusy(true)
    try {
      await resetDemoData()
      // A full reload is the honest way to clear every screen's loaded state,
      // and it is what a fresh walkthrough wants anyway.
      window.location.reload()
    } catch {
      setBusy(false)
    }
  }

  return (
    <button type="button" className={className} onClick={() => void reset()} disabled={busy}>
      {busy ? 'Resetting' : label}
    </button>
  )
}
